<div class="container h-100">
  <div class="row align-items-center h-100">
    <div class="col-3 mx-auto">
      <div class="alert alert-success" role="alert">Your session has ended.</div>
    </div>
  </div>
</div>
<link appMoveToHead href="/dynamic/css/unbranded.css" rel="stylesheet" />
